// src/modules/clientes/view/client-gallery/components/GalleryGrid.tsx
import React from 'react';
import { GalleryItem } from './gallery.types';
import '../../Clientes.css';
import { Play } from 'lucide-react';

type Props = {
    items: GalleryItem[];
    onSelect: (item: GalleryItem) => void;
};

export function GalleryGrid({ items, onSelect }: Props) {
    if (!items.length) return null;

    return (
        <div className="cli-gallery-grid">
            {items.map((it) => (
                <button
                    key={it.id}
                    type="button"
                    className="cli-gallery-item"
                    onClick={() => onSelect(it)}
                    aria-label={`${it.type === 'image' ? 'Foto' : 'Vídeo'} de ${new Date(it.createdAt).toLocaleDateString('pt-BR')}`}
                >
                    {it.type === 'image' ? (
                        <img src={it.url} alt="" loading="lazy" />
                    ) : (
                        <>
                            <video src={it.url} muted playsInline preload="metadata" />
                            <span className="cli-gallery-mark bottom-1.5 left-2" aria-hidden>
                                <Play className="fill-current" aria-hidden="true" />
                            </span>
                        </>
                    )}

                    {it.status === 'uploading' && (
                        <span className="cli-gallery-mark inset-0 bg-black/40" aria-label="Enviando">
                            <span className="loading loading-spinner loading-sm" />
                        </span>
                    )}
                    {it.status === 'error' && (
                        <span className="cli-gallery-mark inset-0 bg-black/50 font-semibold">Erro no envio</span>
                    )}
                </button>
            ))}
        </div>
    );
}
